import React from 'react';

function ArrowDownSvg() {
  return (
    <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.5306 1.53061L6.53063 6.53061C6.46095 6.60053 6.37816 6.65601 6.28699 6.69386C6.19583 6.73172 6.09809 6.7512 5.99938 6.7512C5.90067 6.7512 5.80293 6.73172 5.71176 6.69386C5.6206 6.65601 5.53781 6.60053 5.46813 6.53061L0.468128 1.53061C0.327232 1.38972 0.248077 1.19862 0.248077 0.999362C0.248077 0.800105 0.327232 0.609009 0.468128 0.468112C0.609025 0.327216 0.800121 0.248062 0.999378 0.248062C1.19864 0.248062 1.38973 0.327216 1.53063 0.468112L6 4.93749L10.4694 0.467488C10.6103 0.326592 10.8014 0.247437 11.0006 0.247437C11.1999 0.247437 11.391 0.326592 11.5319 0.467488C11.6728 0.608384 11.7519 0.79948 11.7519 0.998738C11.7519 1.198 11.6728 1.38909 11.5319 1.52999L11.5306 1.53061Z"
        fill="#8279E2"
      />
    </svg>

  );
}

export default ArrowDownSvg;
